import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  mainDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  itemExtra: {
    marginLeft: "10px",
  },
  item: {
    marginLeft: "10px",
    cursor: "pointer",
  },
  changeStatusButtonIcon: {
    cursor: "pointer",
    width: "21px",
    height: "21px",
    marginBottom: "2px",
  },
}));

export default styles;
